<template>
	<div
		class="wrapper wrapper--article"
		:class="customClass"
		ref="wrapper"
		:shareable="articleIsShareable"
		:loading="loading"
		:is-current="isCurrent"
		:is-history="!!historyKey"
		role="article"
	>
		<UiSearch :scope="inferScope()" v-if="/-list$/.test(articleID)" />
		<!-- <UiShare v-if="articleIsShareable" :exhibitionID="exhibitionID" :articleID="articleID" /> -->
		<BlockLoader :blockContent="articleElement" style="width: 100%" ref="blockLoader" />
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import { BlockLoader } from '@/tools/blockLoader';
import { BlockLoader } from 'shoutrlabs-block-loader';
// import UiShare from './ui/share.vue';
import UiSearch from './ui/search.vue';
import { actionTypes, exhibitionTypes, articleTypes } from '@/types';
import { mapStateNested } from '@/tools/helpers';
import { SEARCH_SCOPES } from '@/tools/consts';

export default {
	components: {
		UiSearch,
		// UiShare,
		BlockLoader,
	},
	props: {
		isCurrent: { type: Boolean },
		isInModal: { type: Boolean },
		articleID: String,
		exhibitionID: String,
		previousArticleID: String,
		tourID: String,
		historyKey: String,
		classes: Object,
		customClass: String,
	},
	data() {
		return {
			loading: false,
			imageObserver: null,
			articleData: {},
			articleContent: [],
		};
	},

	computed: {
		...mapState(['dataSourceURL']),
		...mapState(['dataSourceCFG']),
		...mapStateNested('dataSourceCFG', ['exhibitionMap']),
		...mapGetters(['getArticleContentById', 'getBlocksDevHash']),
		articleIsShareable() {
			const exhibition = this.exhibitionMap[this.exhibitionID];
			if (!exhibition) return false;
			const article = exhibition.articleMap[this.articleID];
			return article && article.isShareable;
		},
		currentArticleID() {
			return this.$store.state.currentArticleID;
		},
		currentExhibitionID() {
			return this.$store.state.currentExhibitionID;
		},
		editorApiActive() {
			return this.$store.state.editorApi.active;
		},
		editorApiContent() {
			return this.$store.state.editorApi.content;
		},
		articleElement() {
			const currentArticle = this.$store.getters.currentArticle;
			const currentArticleId = currentArticle?.id;
			const data = this.getArticleContentById(currentArticleId);
			const content = this.editorApiActive ? this.editorApiContent : data?.content;
			const articleElement = content && (content[`id-${currentArticleId}`] || content[currentArticleId]);
			return articleElement ? [articleElement] : [];
		},
		language() {
			return this.$store.state.persistent.language;
		},
	},
	watch: {
		getBlocksDevHash() {
			this.$refs.blockLoader.updateContent();
		},
		async articleID(newID, oldID) {
			if (newID === oldID) return;
			await this.loadContent();
		},
		isCurrent(isCurrent, oldCurrent) {
			if (oldCurrent) {
				// force clear the swipe transform
				this.$el.style.transform = '';
			}
		},
		language(newLang, oldLang) {
			if (newLang !== oldLang) {
				this.loadContent();
			}
		},
	},
	methods: {
		inferScope() {
			if (this.$props.exhibitionID === exhibitionTypes.root && this.articleID === 'exhibition-list')
				return SEARCH_SCOPES.exhibitions;
			if (this.$props.articleID === 'tour-list') return SEARCH_SCOPES.tours;
			if (
				this.$props.exhibitionID === exhibitionTypes.glossary &&
				this.$props.articleID === articleTypes.articleList
			)
				return SEARCH_SCOPES.glossary;
			if (this.$props.articleID.match(/^tour-/)) return SEARCH_SCOPES.tour;
			if (
				this.$props.exhibitionID === exhibitionTypes.calendar &&
				this.$props.articleID === articleTypes.articleList
			)
				return SEARCH_SCOPES.calendar;
			if (this.$props.articleID === articleTypes.articleList) return SEARCH_SCOPES.articles;
		},
		async loadContent() {
			this.loading = true;
			await this.$store.dispatch(actionTypes.loadContent, {
				articleID: this.articleID,
				exhibitionID: this.exhibitionID || this.currentExhibitionID,
				tourID: this.tourID,
			});
			this.loading = false;
			this.$emit('contentLoaded');
		},
	},
	mounted() {
		this.loadContent();
	},
};
</script>
